
export default {
    name: 'MobileProductCard',

    props: {
        product: {
            type: Object,
            default: () => ({}),
        },
    },

    computed: {
        priceOld() {
            if (!this.product.oldPrice || this.product.oldPrice <= this.product.price) {
                return;
            }
            return `${this.$numberFormat(this.product.oldPrice)} ₽`;
        },

        productName() {
            if (this.product?.characteristicGroupId === 2) {
                const room = (this.product?.shortCharacteristics || []).find((t) => t.slug === 'rooms')?.values?.[0]?.value || '';
                const slug = (this.product?.shortCharacteristics || []).find((t) => t.slug === 'rooms')?.values?.[0]?.slug || '';
                if (slug === 'studiya') {
                    return room;
                }

                return `${room}-комнатная квартира`;
            }
            if (this.product?.characteristicGroupId === 1) {
                return `№ паркинга ${this.product.name}`;
            }
            return this.product.name;
        },
        characteristics() {
            const salePriceForMeter = this.product?.shortCharacteristics.find((t) => t?.slug === 'cena-za-m-sale')?.values?.[0]?.value;
            return (this.product?.shortCharacteristics || [])
                .filter((t) => t.show_in_product_card && t.slug !== 'cena-za-m-sale')
                .map((t) => {
                    let value = t?.values?.[0]?.value;
                    if (t.slug === 'cena-za-m' && !salePriceForMeter) {
                        value = this.$numberFormat(value);
                    } else if (t.slug === 'cena-za-m' && salePriceForMeter) {
                      value = this.$numberFormat(salePriceForMeter);
                    }

                    return {
                        title: t?.name_for_product_card || t?.name,
                        value: [value, t.unit].filter((t) => !!t).join(' '),
                    };
                });
        },
    },

    // methods: {
    //     openCallBack() {
    //         const message = `Заявка на бронирование квартиры "${this.product.name}"`;
    //         const additional_data = {
    //             macro_id: parseInt((this.product?.code || '').match(/\d+/)),
    //         };
    //
    //         this.$store.commit('back-call/setOpen', {
    //             open: true,
    //             settings: {
    //                 title: 'Бронирование квартиры',
    //                 formType: 'Бронирование квартиры',
    //                 message,
    //                 additional_data,
    //                 reachGoal: 'bonirovanie',
    //             },
    //         });
    //     },
    // },
};
